<template>
  <div class="set-info">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "SetInfo"
};
</script>

<style lang='less' scoped>
.set-info {
  width: 911px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
</style>